<template>
    <div class="image-page">
      <!-- Use the <img> tag with the :src attribute to display the SVG image -->
        <img :src="imageUrl" alt="My SVG Image" />
        <h2>You don't have permission to access this feature</h2>
        <button class="blue-button" @click="$router.push('/')">Click here to continue</button>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        imageUrl: require('@/assets/Lost.svg') // Adjust the path to your SVG image accordingly
      };
    }
  };
  </script>
  
  <style>
  /* The CSS styles remain the same */
  .image-page {
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }
  .blue-button {
  background-color: #007bff; /* Blue background color */
  color: #ffffff; /* White text color */
  padding: 10px 20px; /* Adjust padding to your preference */
  border: none; /* Remove default button border */
  border-radius: 5px; /* Rounded corners */
  cursor: pointer; /* Show pointer cursor on hover */
  font-size: 16px; /* Adjust font size to your preference */
  font-weight: bold;
}

/* On hover styles (Optional: Adds a subtle effect on hover) */
.blue-button:hover {
  opacity: 0.8; /* Reduce opacity on hover for a subtle effect */
}

  img {
    max-width: 100%;
    max-height: 100%;
  }
  </style>